interface HeroSectionProps {
  onRequestAccess: () => void;
}

export default function HeroSection({ onRequestAccess }: HeroSectionProps) {
  return (
    <section className="flex flex-col items-center text-center px-4 md:px-0">
      <h1 className="font-headline text-[32px] md:text-[48px] leading-[1.15] text-[#1e1c1c] max-w-[720px]">
        Ask ChatGPT to recommend your business. It can't.
      </h1>

      <p className="font-body font-medium text-[16px] text-[rgba(30,28,28,0.7)] leading-[1.5] max-w-[560px] mt-3">
        Millions of people now search through AI instead of Google. If your site
        isn't optimized for AI, you're invisible to all of them.
      </p>

      <button
        onClick={onRequestAccess}
        className="bg-primary rounded text-white p-4 font-body font-semibold text-[16px] mt-8"
      >
        Book Free AI Visibility Review
      </button>

      <span className="font-body font-semibold text-[12px] tracking-[0.6px] uppercase text-[#1e1c1c] opacity-70 mt-5">
        15 minutes. No obligation.
      </span>
    </section>
  );
}
